import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyDollarMediumCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <circle
      cx={8.7}
      cy={7.999}
      r={6.333}
      stroke="#2C9746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#2C9746"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.7 5v.667M8.7 11v-.666M7.272 9.5c.263.54.827.87 1.427.833a1.365 1.365 0 0 0 1.5-1.167v0c0-.504-.355-.937-.85-1.036l-1.3-.26a1.06 1.06 0 0 1-.85-1.037v0a1.365 1.365 0 0 1 1.5-1.167c.6-.036 1.164.293 1.428.834"
    />
  </svg>
);
export default SvgCurrencyDollarMediumCircle;
